import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./pages/milestones/shared/event_hub.js